import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon, MailIcon, MapPinIcon } from 'lucide-react';
const Footer = () => {
  return <footer className="bg-[#1A2B4C] text-white" data-id="element-28">
      <div className="container mx-auto px-4 py-12" data-id="element-29">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-30">
          <div data-id="element-31">
            <h3 className="text-xl font-bold mb-4" data-id="element-32">
              <span className="text-white" data-id="element-33">Elevate</span>
              <span className="text-[#1FC5A8]" data-id="element-34">fix</span>
            </h3>
            <p className="mb-4" data-id="element-35">
              Fast, reliable appliance repairs across the UK.
            </p>
            <div className="flex items-center mb-3" data-id="element-36">
              <PhoneIcon size={18} className="mr-2 text-[#1FC5A8]" data-id="element-37" />
              <span data-id="element-38">0800 055 4969</span>
            </div>
            <div className="flex items-center mb-3" data-id="element-39">
              <MailIcon size={18} className="mr-2 text-[#1FC5A8]" data-id="element-40" />
              <span data-id="element-41">dronakoirala6@gmail.com</span>
            </div>
            <div className="flex items-center" data-id="element-42">
              <MapPinIcon size={18} className="mr-2 text-[#1FC5A8]" data-id="element-43" />
              <span data-id="element-44">1a Tower Workshops, 58 Riley Rd, London SE1 3DG</span>
            </div>
          </div>
          <div data-id="element-45">
            <h3 className="text-xl font-bold mb-4" data-id="element-46">Quick Links</h3>
            <ul className="space-y-2" data-id="element-47">
              <li data-id="element-48">
                <Link to="/" className="hover:text-[#1FC5A8] transition-colors" data-id="element-49">
                  Home
                </Link>
              </li>
              <li data-id="element-50">
                <Link to="/service-coverage" className="hover:text-[#1FC5A8] transition-colors" data-id="element-51">
                  Service Coverage
                </Link>
              </li>
              <li data-id="element-52">
                <Link to="/about" className="hover:text-[#1FC5A8] transition-colors" data-id="element-53">
                  About Us
                </Link>
              </li>
              <li data-id="element-54">
                <Link to="/faqs" className="hover:text-[#1FC5A8] transition-colors" data-id="element-55">
                  FAQs
                </Link>
              </li>
              <li data-id="element-56">
                <Link to="/contact" className="hover:text-[#1FC5A8] transition-colors" data-id="element-57">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-58">
            <h3 className="text-xl font-bold mb-4" data-id="element-59">Policies</h3>
            <ul className="space-y-2" data-id="element-60">
              <li data-id="element-61">
                <Link to="/cancellation-policy" className="hover:text-[#1FC5A8] transition-colors" data-id="element-62">
                  Cancellation Policy
                </Link>
              </li>
              <li data-id="element-63">
                <Link to="/refund-policy" className="hover:text-[#1FC5A8] transition-colors" data-id="element-64">
                  Refund Policy
                </Link>
              </li>
              <li data-id="element-65">
                <Link to="/privacy-policy" className="hover:text-[#1FC5A8] transition-colors" data-id="element-66">
                  Privacy & Cookie Policy
                </Link>
              </li>
              <li data-id="element-67">
                <Link to="/terms" className="hover:text-[#1FC5A8] transition-colors" data-id="element-68">
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-gray-700 text-center" data-id="element-69">
          <div className="flex justify-center mb-4" data-id="element-70">
            <div className="bg-white px-4 py-2 rounded-lg text-[#1A2B4C] flex items-center" data-id="element-71">
              <span className="font-bold" data-id="element-72">UK-Based Support</span>
            </div>
          </div>
          <p data-id="element-73">
            &copy; {new Date().getFullYear()} Elevatefix. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;